import React, { useEffect } from 'react'
import { pick } from 'lodash-es'
import { useTbViewStore } from '@vt/hooks'
import { Loading, Button } from '@ow/comps'
import AreaDetail from './detail'
import StandardDetail from '../standard/detail'
import nulldata from './assets/nulldata.png'
import BatchAdd from './batchAdd'
import AreaControl from './control'
import StandardControl from '../standard/control'
import useAreaStore from './areaStore'

const Content = function ({ type }) {
  const { tbData, tbDefs, loading, setTbData, ditto, setLoading } =
    useTbViewStore((state) =>
      pick(state, [
        'tbData',
        'tbDefs',
        'loading',
        'setTbData',
        'ditto',
        'setLoading',
      ])
    )

  // 要求远洋点位管理，显示“城市“
  const title = type === 'area' ? tbDefs.tbName : '指标'

  const { setAreaState } = useAreaStore((state) =>
    pick(state, ['setAreaState'])
  )

  const loopFetchAllTbData = async () => {
    const result = await ditto.fetchAll()
    setTbData(result)
    setLoading(false)
  }

  useEffect(() => {
    setLoading(true)
    loopFetchAllTbData()
    setAreaState({ isCreateAreaBind: false, ruleId: null })
  }, [])

  return (
    <div className="h-full p-2 w-full">
      {loading && (
        <div className="h-full bg-white flex items-center justify-center">
          <div className="flex flex-col gap-2 text-center items-center justify-center">
            <Loading color="var(--ow-color-primary-700)" />
            <div className="text-primary-700">数据加载中...</div>
          </div>
        </div>
      )}
      {!loading &&
        (tbData && tbData.length === 0 ? (
          <div className="h-full bg-white">
            <div className="p-4 w-full border-b">{title}管理</div>
            <div className="flex items-center justify-center">
              <div className="flex flex-col gap-6">
                <img
                  src={nulldata}
                  alt="nulldata"
                  style={{ width: '300px', height: '260px' }}
                />
                <div className="text-sm text-center">
                  暂无检查{title}，点击【添加{title}】开始添加
                </div>
                <div className="mx-auto">
                  <BatchAdd
                    title={title}
                    type={type}
                    refreshTreeData={(data) => {
                      setTbData(data)
                    }}
                  >
                    <Button type="primary" size="sm">
                      添加{title}
                    </Button>
                  </BatchAdd>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="flex h-full gap-2">
            <div className="bg-white h-full w-1/5">
              {type === 'area' ? (
                <AreaControl type="area" />
              ) : (
                <StandardControl type="standard" />
              )}
            </div>
            <div className="w-4/5 h-full">
              {type === 'area' ? (
                <AreaDetail
                  title={title}
                  type="area"
                  refreshTree={loopFetchAllTbData}
                />
              ) : (
                <StandardDetail
                  title={title}
                  type="standard"
                  refreshTree={loopFetchAllTbData}
                />
              )}
            </div>
          </div>
        ))}
    </div>
  )
}

export default Content
